import { render, staticRenderFns } from "./SignView.vue?vue&type=template&id=04bb226e&scoped=true&"
import script from "./SignView.vue?vue&type=script&lang=js&"
export * from "./SignView.vue?vue&type=script&lang=js&"
import style0 from "./SignView.vue?vue&type=style&index=0&id=04bb226e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb226e",
  null
  
)

export default component.exports